import { LEARN_TYPES } from 'constants/config';

export const createCompoundId = ({ id, type }) => `${type}.${id}`;

/* -- Normalized Object Lookup Helpers -- */

const typeToHitIdKeyMap = new Map([
  [LEARN_TYPES.ELEMENT, 'l_id'],
  [LEARN_TYPES.SECTION, 'l_id'],
  [LEARN_TYPES.LESSON, 'l_id'],
  [LEARN_TYPES.PATH, 'p_id'],
  [LEARN_TYPES.TAG, 't_id'],
]);

function getNormalizedContentTypeForSearchHit(hit) {
  switch (hit.content_type) {
    case LEARN_TYPES.ELEMENT:
    case LEARN_TYPES.SECTION:
      return LEARN_TYPES.LESSON;
    default:
      return hit.content_type;
  }
}

export function getNormalizedContentIdentifiersForSearchHit(hit) {
  const idKey = typeToHitIdKeyMap.get(hit.content_type);
  const id = hit[idKey];
  const type = getNormalizedContentTypeForSearchHit(hit);
  const compoundId = createCompoundId({ id, type });
  return { id, type, compoundId };
}

export function getNormalizedContentIdentifiersForContent(content) {
  const { id, type } = content;
  const compoundId = createCompoundId({ id, type });
  return { id, type, compoundId };
}

export function getAlgoliaIdFieldForContent(content) {
  return typeToHitIdKeyMap.get(content.type);
}
